export const TABLE_BLOCK_01 =  {
  "blockType": "CARDS",
  "blockDesign": "BYOCards",
  "editFormName": "DESIGN_CARD_PANEL",
  "styleProps": {
    "background-color": "#28292c",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to right,,)"
  },
  "headings": [
    {
      "text": "Our Leadership Team",
      "styleProps": {
        "text-align": "center",
        "color": "#ffffff",
        "font-size": "3.75rem",
        "line-height": "1",
        "font-weight": "600"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "Meet the visionaries behind our company:",
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.5rem",
        "line-height": "2rem",
        "margin": "30px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "1.25rem",
        "line-height": "1.75rem"
      },
      "stylePropsMob": {
        "font-size": "1.125rem",
        "line-height": "1.75rem"
      }
    }
  ],
  "cardConfig": {
    "tablestyleProps": {
      "background-color": "",
      "border-width": "1px",
      "border-color": "#333333",
      "border-radius": "1.5rem",
      "box-shadow": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "padding": "0px 0px 0px 0px",
      "margin": "40px 0px 0px 0px"
    },
    "tableTDStyleProps": {
      "background-color": "",
      "border-width": "1px",
      "border-color": "#555555",
      "padding": "12px 24px 12px 24px",
      "color": "#ffffff"
    },
    "tableTHStyleProps": {
      "background-color": "#202124",
      "padding": "14px 24px 14px 24px",
      "font-weight": "400",
      "border-width": "0px",
      "border-color": "#cccccc",
      "color": "#ffffff"
    }
  },
  "table": {
    "columns": [
      {
        "id": "3424234",
        "label": "Id",
        "styleProps": {
          "display": "flex",
          "alignItems": "flex-start",
          "flex-direction": "column",
          "border-width": "0px",
          "border-color": "#cccccc"
        },
        "elements": [
          {
            "id": 1748421653832,
            "params": [
              {
                "value": "id",
                "label": "id"
              }
            ],
            "text": "[[id]] ",
            "type": "text",
            "label": "Id",
            "app": {
              "isExpand": true
            },
            "styleProps": {
              "background-color": "#116dff",
              "color": "#ffffff",
              "border-radius": "0.375rem",
              "padding": "0px 10px 0px 10px",
              "text-align": "center",
              "display": "inline-block"
            }
          }
        ],
        "app": {
          "isExpand": false
        }
      },
      {
        "id": 1748659503626,
        "label": "Pic",
        "elements": [
          {
            "id": 1748659510233,
            "type": "image",
            "params": [
              {
                "value": "img",
                "label": "img"
              }
            ],
            "text": "[[img]]",
            "imgSrc": "img",
            "styleProps": {
              "border-radius": "9999px"
            }
          }
        ],
        "app": {
          "isExpand": true
        }
      },
      {
        "id": 1748421760070,
        "elements": [
          {
            "id": 1748421771547,
            "type": "text",
            "params": [
              {
                "value": "name",
                "label": "name"
              }
            ],
            "text": "[[name]]",
            "app": {
              "isExpand": false
            },
            "styleProps": {
              "font-size": "1.25rem",
              "line-height": "1.75rem",
              "font-weight": "600"
            }
          },
          {
            "id": 1748591827934,
            "type": "text",
            "params": [
              {
                "value": "role",
                "label": "role"
              }
            ],
            "text": "[[role]]",
            "app": {
              "isExpand": false
            },
            "styleProps": {
              "color": "#ffffff99"
            }
          },
          {
            "id": 1748668559677,
            "type": "text",
            "params": [
              {
                "value": "email",
                "label": "email"
              }
            ],
            "text": "[[email]]",
            "imgSrc": "email",
            "styleProps": {
              "color": "#ffffff99"
            }
          }
        ],
        "label": "Employee",
        "app": {
          "isExpand": true
        }
      },
      {
        "id": 1748595925981,
        "label": "Status",
        "elements": [
          {
            "id": 1748595932334,
            "type": "tags",
            "params": [
              {
                "value": "status",
                "label": "status "
              }
            ],
            "text": "[[status ]]",
            "styleProps": {
              "background-color": "#33333333",
              "color": "#ffffff",
              "padding": "0px 10px 0px 10px",
              "border-radius": "1rem",
              "text-align": "center",
              "display": "inline-block",
              "font-size": "0.875rem",
              "line-height": "1.25rem",
              "white-space": "nowrap"
            },
            "tagstyleProps": {
              "background-color": "#5c4345",
              "padding": "0px 10px 0px 10px",
              "border-radius": "0.75rem"
            }
          }
        ],
        "app": {
          "isExpand": true
        },
        "styleProps": {
          "display": "flex",
          "flex-direction": "column",
          "alignItems": "center"
        }
      },
      {
        "id": 1748596080072,
        "label": "Department",
        "elements": [
          {
            "id": 1748596089173,
            "type": "text",
            "params": [
              {
                "value": "department",
                "label": "department"
              }
            ],
            "text": "[[department]]"
          }
        ],
        "app": {
          "isExpand": false
        }
      },
      {
        "id": 1748596098255,
        "label": "Skills",
        "elements": [
          {
            "id": 1748596102977,
            "type": "tags",
            "params": [
              {
                "value": "tags",
                "label": "tags"
              }
            ],
            "text": " [[tags]]",
            "app": {
              "isExpand": true
            },
            "tagstyleProps": {
              "background-color": "#0b75e1",
              "padding": "1px 8px 1px 8px",
              "margin": "2px 4px 2px 4px",
              "border-radius": "0.75rem",
              "color": "#ffffff",
              "white-space": "nowrap"
            },
            "styleProps": {
              "display": "flex",
              "flex-wrap": "wrap"
            }
          }
        ],
        "app": {
          "isExpand": true
        }
      },
      {
        "id": 1748658763951,
        "label": "Description",
        "elements": [
          {
            "id": 1748658772193,
            "type": "text",
            "params": [
              {
                "value": "description",
                "label": "description"
              }
            ],
            "text": "[[description]]",
            "imgSrc": "description",
            "styleProps": {
              "color": "#aaaaaa"
            }
          }
        ],
        "app": {
          "isExpand": true
        }
      }
    ],
    "test": "sdsdsdsdsdsd"
  },
  "configs": {
    "type": "table",
    "dataType": "dynamic",
    "connection": {
      "spreadsheetId": "",
      "sheetName": "",
      "connectionId": "",
      "connectionTable": "",
      "timestamp": 1748669196038,
      "test": true
    },
    "params": [],
    "filters": {
      "categories": []
    },
    "searchConfig": {
      "showSearchBar": false,
      "searchButton": {
        "styleProps": {
          "color": "#ffffff",
          "padding": "5px 20px 5px 20px",
          "background-color": "#333333",
          "border-radius": "1.5rem",
          "margin": "0px 10px 0px 10px",
          "font-weight": "bold",
          "width": "auto"
        },
        "stylePropsMob": {
          "width": "auto"
        }
      },
      "clearButton": {
        "styleProps": {
          "background-color": "#ececec",
          "color": "#333333",
          "padding": "5px 20px 5px 20px",
          "border-radius": "9999px"
        }
      },
      "searchContainer": {
        "styleProps": {
          "background-color": "#ececec",
          "border-radius": "1.5rem",
          "padding": "10px 20px 10px 10px",
          "margin": "30px 0px 30px 0px",
          "width": "auto"
        },
        "stylePropsTab": {
          "border-radius": "9999px"
        },
        "stylePropsMob": {
          "border-radius": "1rem",
          "width": "100%"
        }
      },
      "input": {
        "styleProps": {
          "border-radius": "9999px",
          "padding": "5px 20px 5px 20px",
          "color": "#333333",
          "font-weight": "100",
          "background-color": "#ffffff",
          "width": "auto"
        },
        "stylePropsMob": {
          "margin": "0px 0px 10px 0px",
          "width": "100%"
        }
      }
    },
    "sortBy": {
      "columnName": "",
      "ascending": true
    },
    "id": "1723883803066",
    "useDummyDataSource": false,
    "previewWithTemplateData": false
  },
  "metaDataId": 1748324181200,
  "afterIndex": 1,
  "blockId": 1748324181200,
  "stylePropsTab": {
    "padding": "80px 10px 80px 16px"
  },
  "stylePropsMob": {
    "padding": "60px 16px 60px 16px"
  },
  "overlay": {
    "styleProps": {
      "background-color": ""
    }
  }
}